import * as React from 'react';

import { Typography } from '@emburse/ui-core';

import { BulkUploadCategorySingleDiff } from '@ReactComponents/BulkUploadCategorySingleDiff/BulkUploadCategorySingleDiff';
import { TeamBulkUploadSingleDiff } from '@ReactComponents/TeamBulkUploadSingleDiff';

import { BulkUploadType, IUpdateDiff } from '@Shared/bulk_upload';

interface IBulkUploadWizardErrorDetailsProps {
  errorDiffs: IUpdateDiff[];
  uploadType: BulkUploadType;
}

export class BulkUploadWizardErrorDetails extends React.Component<IBulkUploadWizardErrorDetailsProps> {
  constructor(props: IBulkUploadWizardErrorDetailsProps) {
    super(props);
  }

  render() {
    const { errorDiffs, uploadType } = this.props;

    let Component: React.ComponentClass<{ diff: any }>;
    switch (uploadType) {
      case 'team': {
        Component = TeamBulkUploadSingleDiff;
        break;
      }
      case 'categories': {
        Component = BulkUploadCategorySingleDiff;
        break;
      }
    }

    const count = this.props.errorDiffs.reduce<number>((errorCount, diff) => errorCount + Object.keys(diff.fieldErrorMap).length, 0);

    const details = errorDiffs.map((diff, i) => <Component key={i} diff={diff} />);

    return (
      <div>
        <Typography>
          We found <em>{count}</em> errors in your csv
        </Typography>
        <div className="details">{details}</div>
      </div>
    );
  }
}
